<template>
    <v-row>
        <v-col cols="12" md="6" lg="4" justify="center" offset-md="3" offset-lg="4">
            <v-card class="pa-6" color="transparent" flat>
                <v-img class="logo_tam" alt="Logo" :src="envLogo"></v-img>
                <v-card-title class="text-h5 font-weight-bold justify-center" style="color: #616060; margin-bottom:3rem;">Recuperación de contraseña</v-card-title>
                <v-card-text class="mt-6">
                    <!-- LOGIN FORM -->
                    <v-form align="center" ref="passwordRescueForm" v-model="formValid">
                        <v-text-field
                            solo background-color="white"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[formValidator.password.required, formValidator.password.min]"
                            :type="showPassword ? 'text' : 'password'"
                            label="Nueva contraseña"
                            placeholder="Ingresa una nueva contraseña"
                            @click:append="showPassword = !showPassword"
                             required v-model="request.password"
                            name="password"
                        ></v-text-field>

                        <v-text-field
                            solo background-color="white"
                            :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="[formValidator.password.passwordMatch(request.confirm_password, request.password)]"
                            :type="showRepeatPassword ? 'text' : 'password'"
                            label="Repite la nueva contraseña"
                            placeholder="Confirma la nueva contraseña"
                            @click:append="showRepeatPassword = !showRepeatPassword"
                             required v-model="request.confirm_password"
                        ></v-text-field>
                        <v-row align="center" justify="space-around">
                            <div class="d-flex flex-row">
                                <v-btn @click="updatePassword()"  large class=" main_color_action white--text  flex-fill mr-2 mt-2">Continuar</v-btn>
                            </div>
                        </v-row>
                    </v-form>
                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import registerFormValidator from "@/form/register.form.validator";

export default {
    data() {
        return {
            envLogo: process.env.VUE_APP_LOGO,
            formValidator: registerFormValidator,
            request: {password: null, confirm_password: null, telefono: null, reset_token: null},

            formValid: false,
            showPassword: false,
            showRepeatPassword: false,
        }
    },
    computed: {
        ...mapState({accountStore: state => state.account}),
    },

    created() {
        this.$gtag.event('recuperar_contrasenia', { method: 'Google' }) // Google Analytics
    },

    mounted() {
        if (this.accountStore.loggedIn){
            this.$router.push({name: 'home'})
        }

        this.request.telefono = this.$route.query.telefono
        this.request.reset_token = this.$route.query.reset_token
    },

    methods: {

        ...mapActions('account', ['setNewUserPassword']),

        updatePassword(){
            this.$refs.passwordRescueForm.validate()

            if (this.formValid){
                this.setNewUserPassword(this.request)
            }
        }
    },

};
</script>
<style>
    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
</style>
